export type AvatarType = 'rabbit' | 'cat' | 'dog' | 'bear' | 'panda' | 'fox' | 'penguin' | 'owl' | 'koala';

export interface Avatar {
  id: AvatarType;
  name: string;
  emoji: string;
  color: string;
}

export const AVATARS: Avatar[] = [
  {
    id: 'rabbit',
    name: 'Conejo',
    emoji: '🐰',
    color: 'from-pink-100 to-pink-200'
  },
  {
    id: 'cat',
    name: 'Gato',
    emoji: '🐱',
    color: 'from-orange-100 to-orange-200'
  },
  {
    id: 'dog',
    name: 'Perro',
    emoji: '🐶',
    color: 'from-yellow-100 to-yellow-200'
  },
  {
    id: 'bear',
    name: 'Oso',
    emoji: '🐻',
    color: 'from-amber-100 to-amber-200'
  },
  {
    id: 'panda',
    name: 'Panda',
    emoji: '🐼',
    color: 'from-gray-100 to-gray-200'
  },
  {
    id: 'fox',
    name: 'Zorro',
    emoji: '🦊',
    color: 'from-orange-100 to-orange-200'
  },
  {
    id: 'penguin',
    name: 'Pingüino',
    emoji: '🐧',
    color: 'from-slate-100 to-slate-200'
  },
  {
    id: 'owl',
    name: 'Búho',
    emoji: '🦉',
    color: 'from-amber-100 to-amber-200'
  },
  {
    id: 'koala',
    name: 'Koala',
    emoji: '🐨',
    color: 'from-stone-100 to-stone-200'
  }
];

export const DEFAULT_AVATAR: AvatarType = 'rabbit';
